module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-collapse-transition"
  }, [_c('div', {
    staticClass: "rt-collapse-transition-header",
    on: {
      "click": _vm.collapseClick
    }
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.showContent ? 'rt-base-angle_up' : 'rt-base-angle_down',
      "size": "18",
      "color": "#143E81"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContent),
      expression: "showContent"
    }],
    staticClass: "rt-collapse-transition-content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31af60b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/collapse/rtCollapseTransition.vue
// module id = 1412
// module chunks = 116